export const DocumentInboxTypes = [
  { id: 1, name: "Caixa de Entrada" },
  { id: 2, name: "Favoritos" },
  { id: 3, name: "Visualizados" },
  { id: 4, name: "Arquivados" },
];
